import { Routes, Route } from "react-router-dom";
import Dashboard from "./Pages/Dashboard/DashboardPage";
import Layout from "./Components/Layout";
import Profile from "./Pages/Setting/Profile";
import Settings from "./Pages/Setting/SecuritySettings";
import NotFound from "./utils/NotFound";
import Login from "./Pages/Login/Login";
import PublicRoute from "./Route/PublicRoute";
import PrivateRoute from "./Route/PrivateRoute";
import EditProfile from "./Pages/Setting/EditProfile";
import AllContactUs from "./Pages/contactUs/approve";
import AllUsers from "./Pages/Users/Users";
import AllAdmins from "./Pages/Admins/Admins";
import CreateAdmin from "./Pages/Admins/SaveAdmin";
import CategoryListing from "./Pages/Categories/Category";
import ExamList from "./Pages/Exam/testListing";
import ExamCreate from "./Pages/Exam/testCreate";
import ExamDetails from "./Pages/Exam/testDetails";
import PracticeList from "./Pages/Practice/PracticeList";
import SubjectList from "./Pages/Practice/SubjectList";
import PaperList from "./Pages/Practice/PaperList";
import QuestionList from "./Pages/Practice/QuestionList";
import CategoryQuezze from "./Pages/CategoriesQueze/Category";
import QuizManagement from "./Pages/Queze/Queze";
import QuestionsManagement from "./Pages/Queze/question-mennagement";
import SubscriptionManagement from "./Pages/Subscription/SubscriptionManagement";

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route element={<PublicRoute />}>
        <Route path="/auth/login" element={<Login />} />
      </Route>

      {/* Private routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="/settings/security" element={<Settings />} />
          <Route path="/settings/profile/edit" element={<EditProfile />} />
          <Route path="/settings/profile" element={<Profile />} />
          <Route path="*" element={<NotFound />} />

          <Route path="/contact-us" element={<AllContactUs />} />

          <Route path="/admins" element={<AllAdmins />} />
          <Route path="/save-admin" element={<CreateAdmin />} />

          <Route path="/users" element={<AllUsers />} />
          <Route path="/category/queze" element={<CategoryQuezze />} />
          <Route path="/quezzes" element={<QuizManagement />} />
          <Route
            path="/quiz-questions/:quizId"
            element={<QuestionsManagement />}
          />

          <Route path="/categories" element={<CategoryListing />} />
          <Route path="/subscription" element={<SubscriptionManagement />} />
          <Route path="/test" element={<ExamList />} />
          <Route path="/test/:id" element={<ExamDetails />} />
          <Route path="/test/create" element={<ExamCreate />} />
          <Route path="/admin/practice" element={<PracticeList />} />
          <Route
            path="/admin/practice-subjects/:id"
            element={<SubjectList />}
          />
          <Route
            path="/admin/subject-papers/:subjectId"
            element={<PaperList />}
          />
          <Route path="/admin/paper-details/:id" element={<QuestionList />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
